import React from 'react';
import { Link } from 'react-router-dom';
import { Calendar, DollarSign, Mail, Award, Users, Target } from 'lucide-react';
import SEO from '../components/SEO';

const HomePage = () => {
  return (
    <div className="page-wrapper">
      <SEO 
        title="San Kai Karate Clacton-on-Sea | Traditional Family Karate Dojo Essex"
        description="San Kai Karate Association in Clacton-on-Sea - Traditional, fun, family-friendly karate classes for all ages. Affordable Wado-Ryu martial arts training in Essex since 1988. Join our friendly dojo today!"
        keywords="karate Clacton-on-Sea, karate classes Clacton, martial arts Clacton, Wado-Ryu karate Essex, family karate dojo, affordable karate classes, traditional karate Clacton-on-Sea, kids karate Clacton, karate for children Essex, friendly karate dojo, fun karate classes"
        canonicalPath="/"
      />
      {/* Hero Section */}
      <section className="hero-section">
        <div className="hero-image-container">
          <img 
            src="https://customer-assets.emergentagent.com/job_instructor-bios/artifacts/0fkwrtns_541282368_10162932601145469_8353107557025832179_n.jpg" 
            alt="San Kai Karate Training in Clacton-on-Sea - Traditional Wado-Ryu Martial Arts" 
            className="hero-image"
          />
          <div className="hero-overlay"></div>
        </div>
        <div className="hero-content">
          <img
            src="https://customer-assets.emergentagent.com/job_cobra-dojo/artifacts/ymjdqaqc_2.png"
            alt="San Kai Karate Association Logo Clacton-on-Sea"
            className="hero-logo"
          />
          <h1 className="hero-title">San Kai Karate</h1>
          <p className="hero-subtitle">Traditional Excellence Since 1988</p>
          <div className="hero-buttons">
            <Link to="/schedule" className="btn-primary btn-large">
              View Schedule
            </Link>
            <Link to="/contact" className="btn-secondary btn-large">
              Get Started
            </Link>
          </div>
        </div>
      </section>

      {/* About Section */}
      <section className="about-section">
        <div className="container">
          <div className="section-header">
            <h2 className="section-title">Welcome to San Kai Karate Association</h2>
            <p className="section-subtitle">
              Founded in 1988 by Paul Rees (6th Dan Black Belt), San Kai Karate Association has been providing 
              high-quality martial arts tuition for over 35 years. We combine traditional Japanese Wado-Ryu 
              with complementary styles, welcoming men, women, and children aged 5 and above in a friendly, 
              family-oriented atmosphere.
            </p>
          </div>

          <div className="about-grid">
            <div className="about-card">
              <div className="about-image-container">
                <img 
                  src="https://customer-assets.emergentagent.com/job_instructor-bios/artifacts/p3zla24r_468839704_9491286937567791_4117754607050033691_n.jpg" 
                  alt="Karate Training" 
                  className="about-image"
                />
              </div>
              <div className="about-card-content">
                <Target className="about-icon" />
                <h3 className="about-card-title">Traditional Excellence</h3>
                <p className="about-card-text">
                  Maintaining authentic Wado-Ryu traditions with an eight-grade system to black belt, 
                  while embracing modern training methods to ensure the highest standards of instruction.
                </p>
              </div>
            </div>

            <div className="about-card">
              <div className="about-image-container">
                <img 
                  src="https://customer-assets.emergentagent.com/job_instructor-bios/artifacts/mge7y237_518367550_10162664270445469_6991178459620346749_n.jpg" 
                  alt="Expert Instructors" 
                  className="about-image"
                />
              </div>
              <div className="about-card-content">
                <Award className="about-icon" />
                <h3 className="about-card-title">Expert Instruction</h3>
                <p className="about-card-text">
                  Our NVQ-qualified coaches have over 30 years of training and teaching experience, 
                  with first aid certification—more experience than most clubs in the Essex area.
                </p>
              </div>
            </div>

            <div className="about-card">
              <div className="about-image-container">
                <img 
                  src="https://customer-assets.emergentagent.com/job_instructor-bios/artifacts/8qgh9rbg_518338915_10162664268985469_642790059381780905_n.jpg" 
                  alt="Community Spirit" 
                  className="about-image"
                />
              </div>
              <div className="about-card-content">
                <Users className="about-icon" />
                <h3 className="about-card-title">Family Atmosphere</h3>
                <p className="about-card-text">
                  We foster a welcoming environment for all ages and skill levels, promoting self-confidence, 
                  discipline, fitness, etiquette, and technique alongside strong community relationships.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Cards Section */}
      <section className="cta-section">
        <div className="container">
          <div className="cta-grid">
            <Link to="/schedule" className="cta-card">
              <div className="cta-icon-wrapper green">
                <Calendar size={48} />
              </div>
              <h3 className="cta-card-title">Training Schedule</h3>
              <p className="cta-card-text">
                View our weekly class schedule and find the perfect time for your training sessions.
              </p>
              <span className="cta-arrow">→</span>
            </Link>

            <Link to="/pricing" className="cta-card">
              <div className="cta-icon-wrapper red">
                <DollarSign size={48} />
              </div>
              <h3 className="cta-card-title">Membership Pricing</h3>
              <p className="cta-card-text">
                Explore our flexible pricing options and choose the membership that suits you best.
              </p>
              <span className="cta-arrow">→</span>
            </Link>

            <Link to="/contact" className="cta-card">
              <div className="cta-icon-wrapper green">
                <Mail size={48} />
              </div>
              <h3 className="cta-card-title">Get in Touch</h3>
              <p className="cta-card-text">
                Have questions? Contact us today and start your martial arts journey.
              </p>
              <span className="cta-arrow">→</span>
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
};

export default HomePage;